import { _js } from '@ifixit/localize';
import { Auth } from 'Shared/auth';
import { FormManager } from 'Shared/form_manager';
import { Utils } from 'Shared/utils';
import { throttler } from 'Shared/utils/throttle';
import QuestionAsk from './question_ask';
import { getOrCreateHandle, getEditorid } from 'Shared/prosemirror/answers';
import { AutoPreview } from 'Guide/autopreview';
import { getWordCount } from 'Shared/utils/wordcount';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import {
   focusEditor,
   getSerializedText,
   getText,
   clearSessionStorage,
} from 'Shared/prosemirror/tiptap/editor_cache';

(function () {
   let prosemirror;
   let handle;
   let editorid;

   function updateText() {
      const value = getSerializedText(editorid);
      $('qaText').set('value', value);
   }

   onDomReady(() => {
      let disableDeviceFinder = App.disableDeviceFinder;

      prosemirror = document.querySelector('#qaEditor');
      handle = getOrCreateHandle(prosemirror, '#editor');
      editorid = getEditorid(prosemirror, '#editor');

      const questionTitle = document.querySelector('#questionTitle');
      const questionDescription = document.querySelector('#questionDescription');

      const notEnoughRepQuestionTitle = document.querySelector('#notEnoughRepQuestionTitle');
      const notEnoughRepQuestionDescription = document.querySelector(
         '#notEnoughRepQuestionDescription'
      );

      function showNotEnoughRepQuestionTitle() {
         if (notEnoughRepQuestionTitle) {
            notEnoughRepQuestionTitle.style.display = 'block';
         }
      }

      function hideNotEnoughRepQuestionTitle() {
         if (notEnoughRepQuestionTitle) {
            notEnoughRepQuestionTitle.style.display = 'none';
         }
      }

      function showNotEnoughRepQuestionDescription() {
         if (notEnoughRepQuestionTitle) {
            notEnoughRepQuestionDescription.style.display = 'block';
         }
      }

      function hideNotEnoughRepQuestionDescription() {
         if (notEnoughRepQuestionTitle) {
            notEnoughRepQuestionDescription.style.display = 'none';
         }
      }

      if (questionTitle) {
         questionTitle.addEventListener('mouseover', () => {
            showNotEnoughRepQuestionTitle();
         });

         questionTitle.addEventListener('mouseout', () => {
            hideNotEnoughRepQuestionTitle();
         });
      }

      if (questionDescription) {
         questionDescription.addEventListener('mouseover', () => {
            showNotEnoughRepQuestionDescription();
         });

         questionDescription.addEventListener('mouseout', () => {
            hideNotEnoughRepQuestionDescription();
         });
      }

      // This gets set to true in autopreview.js.
      window.iFixit_hasChanged = false;
      window.iFixit_clickedSubmit = false;
      Utils.UnsavedChanges.addHandler(() => {
         if (window.iFixit_hasChanged && !window.iFixit_clickedSubmit) {
            return _js('You have unsaved changes! Are you sure you want to leave?');
         }
      });

      let editor = $('editor');

      let autoPreview = new AutoPreview('editor', 'questionPreviewContainer', 'getPreview');

      let formManager = new FormManager(editor);
      formManager.addSubmitHandler(() => {
         updateText();
         return true;
      });

      $('content').addEvents({
         'click:relay(.js-continue-question)': function (ev, el) {
            trackAnalyticsCustomEvent({
               eventCategory: 'Ask a Question',
               eventAction: 'Ask a Question - Continue with my question',
            });

            el.getParent('.js-question-title-recommendations').hide();
            focusEditor(editorid);
         },
         'click:relay(.js-preview-question)': function (ev, el) {
            trackAnalyticsCustomEvent({
               eventCategory: 'Ask a Question',
               eventAction: 'Ask a Question - Preview Question',
            });

            updateText();
            formManager.validate(() => {
               autoPreview.checkForQuestionChanges(null, () => {
                  $$('.js-preview-container').show();
                  const submit = $('submitQuestion');
                  submit.jumpTo();
                  setTimeout(() => {
                     submit.focus();
                  }, 500);
               });
            });
         },
         'click:relay(.js-question-submit)': function (ev, el) {
            // Set in Guide/UI/Answers/edit.php
            if (!App.isEdit) {
               trackAnalyticsCustomEvent({
                  eventCategory: 'Ask a Question',
                  eventAction: 'Ask a New Question - Form - Submit',
               });
            } else if (App.isQuestion) {
               trackAnalyticsCustomEvent({
                  eventCategory: 'Edit Question',
                  eventAction: 'Edit Question',
               });
            } else {
               trackAnalyticsCustomEvent({
                  eventCategory: 'Edit Answer',
                  eventAction: 'Edit Answer',
               });
            }
            formManager.submit();
         },
         'click:relay(a.recommendation)': function (ev, el) {
            trackAnalyticsCustomEvent({
               eventCategory: 'Ask a Question',
               eventAction: 'Ask a Question - Choose Existing',
            });
         },
      });

      when($('qaDevice'), deviceField => {
         formManager.setValidator(deviceField, device => {
            let text = device.value;
            if (text.length <= 0 || text.startsWith('Example:')) {
               return formManager.requiredError(device.get('data-requiredError'));
            }
            if (/[#$%&*+,/:;<>?[\\\]^{|}]/.test(text)) {
               return device.get('data-invalidCharsError');
            }

            QuestionAsk.markFinished($$('.js-qa-device-label'), true);
         });

         deviceField.addEventListener('change', () => {
            formManager.validateField(deviceField);
         });
      });

      when($('qaTitle'), titleField => {
         formManager.setValidator(titleField, title => {
            let text = title.value.clean();
            if (text.length <= 0) {
               return formManager.requiredError(_js('Please write a descriptive title.'));
            }

            let wordCount = getWordCount(text);
            if (wordCount < 4) {
               return formManager.requiredError(
                  _js('Titles must be at least four words long before they may be posted.')
               );
            } else if (wordCount > 25) {
               return formManager.requiredError(
                  _js('Titles must be at most %1 words long before they may be posted.').replace(
                     '%1',
                     '25'
                  )
               );
               // We use a word limit because a title with a lot of words
               // can say very little.
            }

            let qualityPoints = QuestionAsk.checkTitle();

            if (qualityPoints < 5) {
               return formManager.requiredError(
                  _js(
                     "Your title isn't good enough. Try making it better! Did you remember to phrase it as a short, descriptive question?"
                  )
               );
            }

            QuestionAsk.markFinished($$('.js-qa-title-label'), true);
         });
      });

      let searchThrottler = throttler(500, QuestionAsk.updateTitleRecommendations);

      when($('qaTitle'), () => {
         let titleFocusTracked = false;
         $('qaTitle').addEvents({
            keydown: searchThrottler.fire,
            keyup: QuestionAsk.checkTitle,
            focus: function () {
               if (!titleFocusTracked) {
                  titleFocusTracked = true;
                  trackAnalyticsCustomEvent({
                     eventCategory: 'Ask a Question',
                     eventAction: 'Ask a Question - Question Title - Focus',
                  });
               }
            },
         });
      });

      // This is a serious cheat: we're using the hidden input to put the
      // validator on (so it will run), but we're not actually validating its
      // contents directly when using ProseMirror.
      formManager.setValidator('qaText', () => {
         let text = getText(editorid);
         text = text.replace(/^\s+/g, ''); // strip leading
         text = text.replace(/\s+$/g, ''); // strip trailing

         if (text.length === 0) {
            return formManager.requiredError(_js('Please ask a question.'));
         }

         if (text.length < App.POST_MIN_CHARS) {
            return formManager.requiredError(
               _js(
                  'Body must be at least %1 characters, you entered %2',
                  App.POST_MIN_CHARS,
                  text.length
               )
            );
         }

         QuestionAsk.markFinished($$('.js-qa-text-label'), true);
      });

      let descriptionFocusTracked = false;
      prosemirror.addEvents({
         keyup: QuestionAsk.checkText,
         focus: function () {
            if (!descriptionFocusTracked) {
               descriptionFocusTracked = true;
               trackAnalyticsCustomEvent({
                  eventCategory: 'Ask a Question',
                  eventAction: 'Ask a Question - Description - Focus',
               });
            }
         },
      });

      // Submit Handler
      formManager.addSubmitHandler(() => {
         Auth.required({
            reload: false,
            message: _js('Log in to ask a question.'),
            onAuthorize: function () {
               if (!window.iFixit_clickedSubmit) {
                  window.iFixit_clickedSubmit = true;
                  clearSessionStorage(editorid);
                  formManager.submitNow();
               }
            },
         });
      });
   });
})();
